import {useEffect, useState} from "react";
import Master from "./Master";
import { Link } from "react-router-dom";

function News(){

  const [news, setNews] = useState([]);

  // LOAD
  const loadNews = async () => {
    const res = await fetch("https://drpatangecitydentalclinic.com/api/allnews.php");
    const data = await res.json();
    setNews(data);
  };

  useEffect(() => {
    loadNews();
  }, []);

    return(
        <Master>
                {/* Page Header Start */}
	<div className="page-header">
		<div className="container">
			<div className="row">
				<div className="col-lg-12">
					{/* Page Header Box Start */}
					<div className="page-header-box">
						<h1 className="text-anime-style-2" data-cursor="-opaque"><span>Our</span> Blog</h1>
						<nav className="wow fadeInUp">
							<ol className="breadcrumb">
								<li className="breadcrumb-item"><a href="./">home</a></li>
								<li className="breadcrumb-item active" aria-current="page">blog</li>
							</ol>
						</nav>
					</div>
					{/* Page Header Box End */}
				</div>
			</div>
		</div>
	</div>
	{/* Page Header End */}

    {/* Page Blog Start */}
    <div className="page-blog">
        <div className="container">
            <div className="row">
                {news.map((n) => (
                <div className="col-lg-4 col-md-6" key={n.id}>
                    {/* Blog Item Start */}
                    <div className="blog-item wow fadeInUp">
                        {/* Post Featured Image Start*/}
                        
                        <div className="post-featured-image" data-cursor-text="View">
                            <figure>
                                <a href={n.image} className="image-anime">
                                    <img src={n.image} alt="News" />
                                </a>
                            </figure>
                        </div>
                        {/* Post Featured Image End */}

                        {/* post Item Body Start */}
                        <div className="post-item-body">
                            <h2><a href="#">{n.headline}</a></h2>
                            <p>{n.news_date}</p>
                        </div>
                        {/* Post Item Body End*/}

                        {/* Post Item Footer Start*/}
                        <div className="post-item-footer">
                            <Link className="read-more-btn" to={`/newsdetails/${n.id}`}>read more</Link>
                        </div>
                        {/* Post Item Footer End*/}
                    </div>
                    {/* Blog Item End */}
                </div>
                ))}

            </div>

            <div className="row">
				<div className="col-md-12">
					{/* Post Pagination Start */}
					<div className="post-pagination wow fadeInUp" data-wow-delay="1.8s">
						<ul className="pagination">
							<li><a href="#"><i className="fa-solid fa-arrow-left-long"></i></a></li>
							<li className="active"><a href="#">1</a></li>
							<li><a href="#">2</a></li>
							<li><a href="#">3</a></li>
							<li><a href="#"><i className="fa-solid fa-arrow-right-long"></i></a></li>
						</ul>
					</div>
					{/* Post Pagination End */}
				</div>
			</div>
        </div>
    </div>
    {/* Page Blog End */}
        </Master>
    );
}

export default News;